<template>
  <div
    id="participants-portal"
    :style="studyStyle"
    v-if="loading == false"
    :class="{
      rtl: getParticipantsPortalLanguages && getParticipantsPortalLanguages.language_culture == 'HE',
      viewport: isViewportApplicable
    }"
  >
    <PortalHeader v-show="!showVideoCall" :studyId="studyId" :globalElement="globalElements" :options="options" @onCancel="onCancelClick" @onBackBtnClick="onBackClick" />
    <div class="container tablet-container">
      <TelehealthVideoCall v-show="showVideoCall" :appointmentId="appointmentId" @windowVisibility="evt => (showVideoCall = evt)" :studyId="studyId" :languageId="languageId" :countryId="countryId" :isOnCancelClick="isOnCancelClick" :isOnBackClick="isOnBackClick" :globalElement="globalElements"></TelehealthVideoCall>
      <router-view v-show="!showVideoCall" :studyId="studyId" :languageId="languageId" :countryId="countryId" :isOnCancelClick="isOnCancelClick" :isOnBackClick="isOnBackClick" :globalElement="globalElements" @updateLanguage="updateLanguage" @updateCountry="updateCountry" @setHeaderOptions="setHeaderOptions"></router-view>
    </div>
  </div>
</template>
<script>
import nprogress from "nprogress";
import PortalHeader from "@/components/participant-portal/header";
import { ParticipantPortal, Widget } from "@/components/services/participant-service";
import { mapGetters } from "vuex";
import TelehealthVideoCall from "@/components/participant-portal/telehealth/video-call";
import localStorageService from "@/services/localStorage";

export default {
  name: "participants-web-auth",
  components: { PortalHeader, TelehealthVideoCall },
  data() {
    return {
      loading: true,
      showVideoCall: false,
      appointmentId: null,
      portal: new ParticipantPortal(),
      widget: new Widget(),
      clientid: this.$route.params.clientId,
      studyId: this.$route.params.studyId,
      countryId: this.$route.params.countryId,
      languageId: this.$route.params.languageId,
      version: this.$route.params.version,
      type: this.$route.params.type,

      options: {},
      language: null,
      country: null,
      selectedStudyId: null,
      directRoutes: ["participants-web", "participants-web-join"],
      isOnCancelClick: false,
      isOnBackClick: false
    };
  },
  computed: {
    ...mapGetters(["getParticipantsPortalLanguages"]),
    globalElements() {
      return this.$store.getters.getParticipantsPortalGlobalElements;
    },
    studyStyle() {
      if (this.globalElements) {
        return {
          "--primary": this.globalElements.colorPrimary ? this.globalElements.colorPrimary : "#4B628B",
          "--secondary": this.globalElements.colorSecondary ? this.globalElements.colorSecondary : "#c4c4c4"
        };
      } else {
        return { "--primary": "#4B628B", "--secondary": "#c4c4c4" };
      }
    },
    isViewportApplicable() {
      return this.$route.fullPath.includes("/dashboard") || this.$route.fullPath.includes("/profile");
    }
  },
  async mounted() {
    nprogress.start();
    await this.checkCountryDomain();
    this.setup();
    this.$root.$on("setHeaderOptions", data => {
      this.options = { ...this.options, ...data };
    });
    this.$root.$on("showVideoCall", data => {
      if (data && data.show) {
        this.showVideoCall = true;
      } else {
        this.appointmentId = data.appointmentId;
      }
    });
  },
  watch: {
    language() {
      if (this.portal.isCountryLanguageAvailable()) {
        this.$router.push({ name: "participants-portal-auth-login" });
      }
    },
    country() {
      if (this.portal.isCountryLanguageAvailable()) {
        this.$router.push({ name: "participants-portal-auth-login" });
      }
    }
  },
  methods: {
    async checkCountryDomain() {
      if (!this.countryId || !this.studyId) {
        return;
      }
      const currentDomain = window.location.hostname;
      try {
        const response = await this.$api.getCountryDomain({ studyId: this.studyId, countryId: this.countryId });
        const countryDomain = response.body;
        if (currentDomain != "localhost" && currentDomain != countryDomain.baseUrlWeb) {
          let currentUrl = window.location.href;
          currentUrl = currentUrl.replace(currentDomain, countryDomain.baseUrlWeb);
          window.location.href = currentUrl;
        }
      } catch (error) {}
    },
    onCancelClick() {
      this.isOnCancelClick = this.isOnCancelClick != true;
    },
    onBackClick() {
      this.isOnBackClick = this.isOnBackClick != true;
    },
    setup() {
      /** If Landed from Recruitment Site */
      if (this.$route.query && this.$route.query.flow && this.$route.query.flow == "web") {
        this.portal.setLocalStorage("pw-isFromWeb", true);
      } else {
        this.portal.setLocalStorage("pw-isFromWeb", false);
      }
      /** If Landed from Recruitment Site */

      /** If Landed from Email for Open Study */
      if (this.$route.query && Object.keys(this.$route.query).includes("openEnrollment") && this.$route.query.openEnrollment) {
        this.portal.setLocalStorage("pw-isOpenStudy", true);
        this.portal.setLocalStorage("pw-openEnrollEmail", this.$route.query && this.$route.query.email);
      } else {
        this.portal.setLocalStorage("pw-isOpenStudy", false);
      }
      /** If Landed from Email for Open Study */

      if (this.$route.params.studyId && this.$route.params.studyId !== "0" && !this.portal.isLoggedIn()) {
        this.portal.setLocalStorage("pw-version", this.version);
        this.portal.setLocalStorage("pw-studyId", this.studyId);
        this.portal.setLocalStorage("pw-countryId", this.countryId);
        this.portal.setLocalStorage("pw-languageId", this.languageId);
        this.getStudyDetails();
        if (this.$route.query.flow != "web") {
          this.getAppLangaString(this.languageId);
        }
        this.getLanguageCountries().then(
          () => {
            this.handleRedirection();
          },
          error => {
            const message = this.widget.translate(error.message, "Web feature is not available.");
            this.$toastr.error(message);
          }
        );
      } else {
        this.getLanguageCountries().then(() => {
          this.handleRedirection();
        });
      }
    },
    getStudyDetails() {
      this.$api
        .getStudyDetail(this.portal.getStudy())
        .then(res => {
          this.portal.setLocalStorage("pw-verification-method", res.data && res.data.verificationMethod);
        })
        .catch(() => {});
    },
    getAppLangaString(languageId) {
      this.portal
        .getApplangaTranslations(languageId)
        .then(() => {})
        .catch(error => {
          const message = this.widget.translate(error.message, "Problem in fetching language translations.");
          this.$toastr.error(message);
        });
    },
    getLanguageCountries() {
      return this.portal.getCountryLanguages();
    },
    handleRedirection(name) {
      this.loading = false;
      nprogress.done();
      let searchFor = name || this.$route.name;
      if (this.portal && this.portal.studyDetails && this.portal.studyDetails.countryId && this.portal.studyDetails.languageId && this.portal.studyDetails.studyId && this.portal.studyDetails.version) {
        searchFor = "participants-web-join";
      }
      if (this.portal.isLoggedIn()) {
        /** Redirect to Dashboard if already logged IN */
        this.isParticipantAlreadyLoggedIn(searchFor);
        /** Redirect to Dashboard if already logged IN */
      } else {
        switch (searchFor) {
          case "participants-web-join":
            this.$router.push({
              name: "participants-portal-auth-join",
              params: { studyId: this.studyId }
            });
            break;
          case "participants-portal":
            this.$router.push({
              name: "participants-portal",
              params: { studyId: this.studyId }
            });
            break;
          case "participants-web-sign":
            this.$router.push({
              name: "participants-portal-auth-login",
              params: { studyId: this.studyId }
            });
            break;
          case "participants-portal-auth-login":
            this.$router.push({ name: "participants-portal-auth-login" });
            break;
          case "participants-portal-web-login":
            this.$router.push({ name: "participants-portal-auth-login" });
            break;
          case "participants-portal-auth-forgot-password":
            this.$router.push({
              name: "participants-portal-auth-forgot-password"
            });
            break;
          case "participants-portal-auth-forgot-username":
            this.$router.push({
              name: "participants-portal-auth-forgot-username"
            });
            break;
          default:
            this.$router.push({ name: "participants-portal-auth-location" });
            break;
        }
      }
    },
    getDetails() {
      return this.portal.getGlobalElementsData();
    },
    isParticipantAlreadyLoggedIn(searchFor) {
      const that = this;
      this.loading = true;
      this.portal
        .getBitriseData()
        .then(
          () => {
            this.portal.getGlobalElementsObject();
            that.loading = false;
            switch (searchFor) {
              case "participants-portal-activities":
                this.$router.push({
                  name: "participants-portal-activities",
                  params: {
                    studyId: this.portal.getStudy(),
                    languageId: this.portal.getLanguage()
                  }
                });
                break;
              case "participants-portal-activity-list":
                this.$router.push({
                  name: "participants-portal-activities",
                  params: {
                    studyId: this.portal.getStudy(),
                    languageId: this.portal.getLanguage()
                  }
                });
                break;
              case "participants-portal-dashboard":
                this.$router.push({
                  name: "participants-portal-dashboard",
                  params: {
                    studyId: this.portal.getStudy(),
                    languageId: this.portal.getLanguage()
                  }
                });
                break;
              case "participants-portal-learn":
                this.$router.push({
                  name: "participants-portal-learn",
                  params: {
                    studyId: this.portal.getStudy(),
                    languageId: this.portal.getLanguage()
                  }
                });
                break;
              case "participants-portal-profile":
                this.$router.push({
                  name: "participants-portal-profile",
                  params: {
                    studyId: this.portal.getStudy(),
                    languageId: this.portal.getLanguage()
                  }
                });
                break;
              default:
                this.$router.push({
                  name: "participants-portal-activities",
                  params: {
                    studyId: this.portal.getStudy(),
                    languageId: this.portal.getLanguage()
                  }
                });
                break;
            }
            that.$router.push({
              name: "participants-portal-activities",
              params: {
                studyId: this.portal.getStudy(),
                languageId: this.portal.getLanguage()
              }
            });
          },
          () => {
            that.loading = false;
          }
        )
        .catch(() => {
          that.loading = false;
        });
    },
    setHeaderOptions(options) {
      this.options = options;
    },
    updateLanguage(language) {
      this.language = language;
    },
    updateCountry(country) {
      this.country = country;
    },
    updateStudy(studyId) {
      if (studyId) {
        this.isStudySelected = true;
        this.selectedStudyId = studyId;
        const study = this.studies.find(o => o.studyId == studyId);
        this.$api
          .getParticipantsProfileDetails(study.participantId)
          .then(response => {
            const participant = response.data;
            participant.myStudyVersionId = participant.studyVersionId;
            localStorageService.setItem("pw-studyId", studyId);
            this.$store.dispatch("participantUpdate", participant);
          })
          .catch(e => {
            const message = this.widget.translate(e.message, "Problem in fetching profile details.");
            this.$toastr.error(message);
          });
      } else {
        const message = this.widget.translate("pweb_select_study", "Please select a study");
        this.$toastr.error(message);
      }
    }
  }
};
</script>
<style>
@import url("../../assets/participants-portal.scss");
.loader {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3e77a9;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
  margin: calc(50vh - 60px) auto;
}

.modal-dialog {
  min-width: 500px;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
